export default __webpack_public_path__ + "static/media/workflow-node-delete.c089d0a5.png";